export default __webpack_public_path__ + "static/media/10.2ca9cd01.png";